export type InviteStepCopy = { title: string; desc: string };

export const resolveInviteStepCopy = (isAutomaticTracking: boolean): InviteStepCopy => {
  if (isAutomaticTracking) {
    return {
      title: 'onboarding:invite_members_step.automatic_tracking.title',
      desc: 'onboarding:invite_members_step.automatic_tracking.desc',
    };
  }

  return {
    title: 'onboarding:invite_members_step.title',
    desc: 'onboarding:invite_members_step.desc',
  };
};

export const withInviteStepCopy = <T extends { id: string; title?: string; desc?: string }>(
  step: T,
  isAutomaticTracking: boolean,
): T => {
  if (step.id !== 'sendInvitesStep') return step;

  return {
    ...step,
    ...resolveInviteStepCopy(isAutomaticTracking),
  };
};
